import PersonRecentContact from './PersonRecentContact';

export default PersonRecentContact;
